import moment from "moment";

export const dateUtcToLocal = (date: string | Date): Date => moment.utc(date).local().toDate();

export const dateUtcToLocalShort = (date: string | Date): String => moment.utc(date).local().format("MMM.DD HH:mm");
